module.exports = __webpack_public_path__ + "img/IMG_6689_L_WoodMatted.6f61f38e.jpg";